module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar",
    class: {
      sidebar_opened: !_vm.sidebarShow
    }
  }, [_c('Toggle', {
    attrs: {
      "sidebarShow": _vm.sidebarShow
    },
    on: {
      "click": _vm.toggleSidebar
    }
  }), _c('Header', [_vm._v("Пользователи")]), (_vm.formOpen) ? _c('Accordion', {
    attrs: {
      "opened": _vm.formOpen
    }
  }) : [_c('LoadingSpinner', {
    attrs: {
      "showContent": !_vm.isLoading,
      "size": 70
    }
  }, [(_vm.errorText) ? _c('Infotext', {
    attrs: {
      "padding": true,
      "text": _vm.errorText
    }
  }) : (_vm.user) ? _c('ChildrenList', {
    attrs: {
      "item": _vm.user,
      "modules": _vm.modules
    }
  }) : _vm._e()], 1)], _c('Footer', [_vm._v("Полезные ссылки"), _c('template', {
    slot: "link"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: "blog"
      }
    }
  }, [_vm._v("Блог")])], 1)], 2)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32f42b8c","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/blocks/children/sidebar/Sidebar.vue
// module id = 3417817b0bef0fd6d92d
// module chunks = 89